import { render, staticRenderFns } from "./RichMenuTemplateAdd.vue?vue&type=template&id=0602832f&"
import script from "./RichMenuTemplateAdd.vue?vue&type=script&lang=js&"
export * from "./RichMenuTemplateAdd.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuTemplateAdd.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RichMenuTemplateAdd.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./RichMenuTemplateAdd.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports